import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col
} from 'reactstrap';
import LabelInput from '@src/components/LabelInput/LabelInput';
import { required, maxLength } from '@src/validation';
import ProgressBox from '@src/components/ProgressBox/ProgressBox';
import axiosInstance from '@src/axios-instance';

const fieldValidator = {
  body: [required, value => maxLength(value, 280)]
};
class AnnoucementModal extends React.Component {
  constructor(props) {
    super(props);
    const fields = {};

    Object.keys(fieldValidator).forEach(key => {
      fields[key] = {
        value:
          props.entity[key] !== undefined && props.entity[key] !== null
            ? props.entity[key]
            : '',
        visited: false,
        error: false
      };
    });

    this.state = { ...fields, managementCompanies: [], developers: [] };
  }

  updateForm = (event, name) => {
    const inputData = {
      value:
        event !== null && event.target !== undefined
          ? event.target.value
          : event,
      visited: true,
      error: false
    };

    for (let i = 0; i < fieldValidator[name].length; i++) {
      const validationMsg = fieldValidator[name][i](inputData.value);
      if (validationMsg !== undefined) {
        inputData.error = validationMsg;
        break;
      }
    }

    this.setState({
      [name]: inputData
    });
  };

  submitHandler = e => {
    e.preventDefault();
    const formData = JSON.parse(JSON.stringify(this.state));
    const postData = {};
    let isValid = true;

    Object.keys(fieldValidator).forEach(key => {
      postData[key] =
        formData[key].value.value !== undefined
          ? formData[key].value.value
          : formData[key].value;
      for (let i = 0; i < fieldValidator[key].length; i++) {
        const validationMsg = fieldValidator[key][i](formData[key].value);
        formData[key].visited = true;
        if (validationMsg !== undefined) {
          formData[key].error = validationMsg;
          isValid = false;
          break;
        } else {
          formData[key].error = false;
        }
      }
    });

    this.setState({ ...formData });

    if (isValid) {
      if (
        this.props.entity !== undefined &&
        this.props.entity.id !== undefined
      ) {
        this.onEdit(postData);
      } else {
        this.onCreate(postData);
      }
    }
    return false;
  };

  onEdit = postData => {
    axiosInstance()
      .put(`/announcements/${this.props.entity.id}.json`, postData)
      .then(response => {
        this.props.toggle();
        this.props.callback();
      })
      .catch(err => {
        alert(err);
      });
  };

  onCreate = postData => {
    axiosInstance()
      .post('/announcements.json', postData)
      .then(response => {
        this.props.toggle();
        this.props.callback();
      })
      .catch(err => {
        alert(err);
      });
  };

  render = () => {
    return (
      <Modal
        isOpen={this.props.isActive}
        toggle={this.props.toggle}
        className={this.props.className}
        size={'lg'}
      >
        <form
          ref={c => {
            this.form = c;
          }}
          onSubmit={this.submitHandler.bind(this)}
        >
          <ModalHeader toggle={this.props.toggle}>
            {this.props.entity.id !== undefined
              ? 'Edit Announcement'
              : 'Post New Announcement'}
          </ModalHeader>
          <div className={'position-relative'}>
            {this.props.loading && <ProgressBox text={'Submiting ...'} />}
            <ModalBody className={'p-4'}>
              <Row>
                <Col>
                  <LabelInput
                    name={'Notes'}
                    type={'textarea'}
                    required={true}
                    rows={6}
                    {...this.state.body}
                    onChange={event => this.updateForm(event, 'body')}
                  />
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter className={'py-4'}>
              <Button color="primary" className={'btn px-3'} type={'submit'}>
                Post
              </Button>
            </ModalFooter>
          </div>
        </form>
      </Modal>
    );
  };
}
export default AnnoucementModal;
